export const areArraysEqual = (a: any[], b: any[]) => {
    if (a.length !== b.length) {
        return false
    }
    const aSorted = a.sort()
    const bSorted = b.sort()

    return aSorted
        .map((val: any, i: number) => bSorted[i] === val)
        .every((isSame: boolean) => isSame)
}
